/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, backwardsCompatabilityFactory, QueryStateSchema } from './queryStateParser';

const QS_KEY = 'paneWorkflowDocumentsId';
const QS_TYPE: QueryStateSchema['type'] = 'userWorkflowDocuments';

export const useOpenWorkflowDocumentsPane = (): ((args: { workflowDocumentsId: string }) => void) => {
  const [workflowDocumentsIdDeprecated, setWorkflowDocumentsId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (workflowDocumentsIdDeprecated) {
      setWorkflowDocumentsId(null);
      setState(backwardsCompatabilityFactory({ id: workflowDocumentsIdDeprecated, type: QS_TYPE }));
    }
  }, [workflowDocumentsIdDeprecated]);

  return ({ workflowDocumentsId }): void => {
    setState(prevState => [...(prevState || []), {
      id: workflowDocumentsId,
      key: nanoid(),
      type: QS_TYPE,
    }]);
  };
};
